<template>
  <div v-if="opened" class="alerts">
    <div class="alert-wrapper fixed">
      <div
        class="alert"
        :class="{ 'alert-danger': error, 'alert-success': !error }"
      >
        <div
          class="alert__inner d-flex align-items-center justify-content-between"
        >
          <span class="alert__text">{{ $t(text) }}</span>
          <div>
            <a class="ml-3 font-weight-bolder" @click="close">{{ $t("ok") }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import _ from "lodash";
//import axios from "axios";
export default {
  props: {
    error: Boolean,
    opened: Boolean,
    text: String
  },
  data() {
    return {};
  },
  computed: {},
  watch: {
    opened() {
      if (this.opened == true) {
        this.timeoutClose();
      }
    }
  },
  mounted() {},
  methods: {
    timeoutClose() {
      setTimeout(() => this.close(), 5000);
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped></style>
